// src/screens/AboutBarterFi.js
import React, { useEffect, useRef } from 'react';
import './AboutBarterFi.css';
import backIcon from '../assets/backspace-icon.png';
import Screen from '../Screen';
import { useTranslation, Trans } from 'react-i18next';

function AboutBarterFi() {
  const { t } = useTranslation();
  const merchantRef = useRef(null);
  const withdrawalPolicyRef = useRef(null);

  useEffect(() => {
    if (window.location.hash === '#merchant') {
      merchantRef.current?.scrollIntoView({ behavior: 'smooth' });
    } else if (window.location.hash === '#withdrawals') {
      withdrawalPolicyRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <Screen>
      <div className="aboutbarterfi-container">
        <div className="aboutbarterfi-topbar">
          <img
            src={backIcon}
            alt={t('about.back')}
            className="aboutbarterfi-back-icon"
            onClick={() =>
              window.history.length <= 1
                ? (window.location.href = '/home')
                : window.history.back()
            }
          />
          <h2 className="aboutbarterfi-title">{t('about.title')}</h2>
        </div>

        <div className="aboutbarterfi-scroll-area">
          <div className="aboutbarterfi-content">
            <h3>{t('about.what_is.title')}</h3>
            <p>{t('about.what_is.body')}</p>

            <h4>{t('about.mission.title')}</h4>
            <p>{t('about.mission.body')}</p>

            <h4>{t('about.vision.title')}</h4>
            <p>{t('about.vision.body')}</p>

            <h4>{t('about.pillars.title')}</h4>
            <ul>
              <li>
                <Trans
                  i18nKey="about.pillars.connect"
                  components={{ strong: <strong /> }}
                />
              </li>
              <li>
                <Trans
                  i18nKey="about.pillars.trust"
                  components={{ strong: <strong /> }}
                />
              </li>
              <li>
                <Trans
                  i18nKey="about.pillars.transact"
                  components={{ strong: <strong /> }}
                />
              </li>
            </ul>

            <h4>{t('about.how_it_works.title')}</h4>
            <p>{t('about.how_it_works.body')}</p>

            <h4>{t('about.wallet_activation.title')}</h4>
            <p>
              <Trans
                i18nKey="about.wallet_activation.body"
                components={{ strong: <strong /> }}
              />
            </p>
            <p>
              <Trans
                i18nKey="about.wallet_activation.body2"
                components={{ strong: <strong /> }}
              />
            </p>

            <h4>{t('about.why_different.title')}</h4>
            <ul>
              <li>
                <Trans
                  i18nKey="about.why_different.points.social"
                  components={{ strong: <strong /> }}
                />
              </li>
              <li>
                <Trans
                  i18nKey="about.why_different.points.discovery"
                  components={{ strong: <strong /> }}
                />
              </li>
              <li>
                <Trans
                  i18nKey="about.why_different.points.trust"
                  components={{ strong: <strong /> }}
                />
              </li>
              <li>
                <Trans
                  i18nKey="about.why_different.points.escrow"
                  components={{ strong: <strong /> }}
                />
              </li>
              <li>
                <Trans
                  i18nKey="about.why_different.points.pricing"
                  components={{ strong: <strong /> }}
                />
              </li>
              <li>
                <Trans
                  i18nKey="about.why_different.points.browser"
                  components={{ strong: <strong /> }}
                />
              </li>
            </ul>

            <h4>{t('about.escrow.title')}</h4>
            <p>{t('about.escrow.body')}</p>

            <h5>{t('about.order_example.title')}</h5>
            <p>
              <Trans i18nKey="about.order_example.body" />
            </p>

            <h4>{t('about.phase.title')}</h4>
            <p>
              <Trans
                i18nKey="about.phase.body"
                components={{ strong: <strong /> }}
              />
            </p>

            <div ref={merchantRef}>
              <h3>{t('about.merchant.title')}</h3>
              <p>{t('about.merchant.body')}</p>

              <h4>{t('about.merchant.benefits_title')}</h4>
              <ul>
                <li>
                  <Trans
                    i18nKey="about.merchant.benefits.badge"
                    components={{ strong: <strong /> }}
                  />
                </li>
                <li>{t('about.merchant.benefits.unlimited')}</li>
                <li>{t('about.merchant.benefits.pricing')}</li>
                <li>{t('about.merchant.benefits.analytics')}</li>
                <li>{t('about.merchant.benefits.promotions')}</li>
              </ul>

              <h4>{t('about.merchant.apply_title')}</h4>
              <ol>
                <li>
                  <Trans
                    i18nKey="about.merchant.apply.1"
                    components={{ em: <em />, strong: <strong /> }}
                  />
                </li>
                <li>
                  <Trans
                    i18nKey="about.merchant.apply.2"
                    components={{ em: <em />, strong: <strong /> }}
                  />
                </li>
                <li>
                  <Trans
                    i18nKey="about.merchant.apply.3"
                    components={{ em: <em />, strong: <strong /> }}
                  />
                </li>
                <li>
                  <Trans
                    i18nKey="about.merchant.apply.4"
                    components={{ em: <em />, strong: <strong /> }}
                  />
                </li>
                <li>
                  <Trans
                    i18nKey="about.merchant.apply.5"
                    components={{ em: <em />, strong: <strong /> }}
                  />
                </li>
              </ol>

              <h4>{t('about.merchant.fee_title')}</h4>
              <p>{t('about.merchant.fee_body').replace(/&nbsp;/g, ' ')}</p>
            </div>

            <div ref={withdrawalPolicyRef}>
              <h3>{t('about.withdrawals.title')}</h3>
              <p>{t('about.withdrawals.p1')}</p>
              <p>{t('about.withdrawals.p2')}</p>
              <p>
                <Trans
                  i18nKey="about.withdrawals.warning"
                  components={{ strong: <strong />, u: <u /> }}
                />
              </p>
            </div>

            <p style={{ marginTop: 30, fontSize: 14, color: '#888' }}>
              {t('about.version', { version: '1.0.0', author: 'Sizwe Eldwin Mondlane' })}
            </p>
          </div>
        </div>
      </div>
    </Screen>
  );
}

export default AboutBarterFi;
